var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hi",
    "data-name": "hi",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 454.32 977.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hi_bill",
    "data-name": "hi bill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hi_",
    "data-name": "hi!"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m97.84,200.01c5.05-1.62,8.97-2.77,12.81-4.12,14.76-5.21,29.94-9.24,45.46-5.44,16.62,4.07,31.53,11.4,36.84,29.86,3.02,10.52,1.06,20.86-2.1,30.93-5.41,17.29-11.49,34.37-16.69,51.71-2.95,9.83-5.13,19.94-6.85,30.06-1.5,8.82,1.53,12.93,9.92,15.93.94.34,1.9.62,2.84.97,4.19,1.57,8.19,3.35,8.02,8.84-.13,4.43-4,9.01-8.92,10.28-19.12,4.95-36.02.11-50.76-12.41-12.19-10.36-15.45-24.06-12.9-39.37,3.18-19.05,10.83-36.66,17.83-54.48,5.05-12.85,10.32-25.62,14.98-38.61,1.65-4.59,2.22-9.7,2.51-14.62.24-4.22-2.36-7.11-6.55-8.34-20.68-6.05-43.34,6.13-50.61,20.22-3.75,7.26-5.36,15.69-7.47,23.72-6.81,25.86-13.58,51.74-19.94,77.71-1.69,6.88-1.77,14.15-2.7,21.22-.72,5.46,1.21,8.86,6.74,10.41,2.3.65,4.53,2.19,6.35,3.83,6.1,5.48,4.72,13.45-2.93,16.3-8.36,3.12-17.18,3.34-25.58.93-11.37-3.27-21.07-9.85-29.49-18.16-10.86-10.73-11.68-23.94-8.22-37.65,7.85-31.11,16.02-62.14,24.21-93.16,10.43-39.51,21.31-78.9,31.35-118.51,2.84-11.2,4.02-22.93,4.75-34.5.35-5.55-1.78-11.39-3.46-16.89-1.5-4.92-5.05-6.67-10.54-5.75-10.74,1.8-21.62,2.22-32.02-1.89-2.71-1.07-6.89-3.62-6.83-5.36.1-2.73,2.66-6.21,5.18-7.87,10.14-6.67,21-11.51,33.68-10.27,11.42,1.11,23.01,1.28,33.44,7.09,18.66,10.38,26.42,27.37,28.81,47.55,1.77,14.93-.28,29.64-3.59,44.13-5.03,22.05-10.59,43.97-15.87,65.96-.65,2.72-.97,5.51-1.69,9.73Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.11,246.35c.28-19.7,5.42-38.49,9.95-57.46,9.42-39.45,18.31-79.02,27.3-118.57,1.33-5.83,2.13-11.8,2.89-17.73.38-2.94.54-6.03.05-8.93-1.19-7.09-2.2-7.37-9.37-8.07-4.52-.44-9.06-1.79-13.31-3.44-3.02-1.17-4.18-4.19-1.86-6.99,12.33-14.85,37.54-31.39,62.25-22.78,15.76,5.49,25.12,17.23,24.16,33.81-1.11,19.06-2.84,38.09-8.16,56.68-3.38,11.8-4.74,24.16-7.39,36.18-7.09,32.2-16.53,63.69-28.65,94.38-4.08,10.34-7.95,20.85-7.64,32.33.21,7.76,2.81,14.56,7.14,20.92,4.86,7.12,1.92,13.74-6.69,14.65-15.07,1.58-28.7-2.54-40.72-11.65-6.79-5.15-8.44-12.91-9.21-20.85-.4-4.14-.5-8.31-.73-12.46Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.76,241.91c-2.18,10.89-5.3,27.54-8.9,44.09-2.65,12.16-6.04,24.15-8.87,36.28-1.53,6.55-2,8.28,4.55,13.01,4.09,2.96,7.48,7.08,10.62,11.12,3.09,3.97,1.82,10.62-2.52,13.84-9.77,7.25-20.92,9.32-32.66,6.95-11.86-2.39-21.82-8.76-30.99-16.44-11.43-9.58-12.32-21.14-8.02-34.75,8.47-26.81,15.96-53.93,24.12-80.85,1.41-4.65-.34-6.62-4.24-7.72-3.51-.99-7.33-1.18-10.57-2.68-2.29-1.06-4.43-3.46-5.45-5.78-.4-.91,2.16-3.56,3.8-4.88,13.51-10.82,29.18-13.29,45.73-10.75,15.42,2.37,23.59,14.19,23.4,38.57Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.66,377.43c-15.52-.27-28.15-3.78-39.09-12.24-6.76-5.23-10.26-12.11-9.29-20.87.84-7.61,1.95-15.12-2.36-22.34-1.72-2.88.06-6.15,3.33-6.43,11.2-.98,22.56-2.68,33.63-1.64,10.06.94,17.41,11.11,18.76,21.44.5,3.78.5,7.8,1.91,11.23,1.49,3.61,3.84,7.28,6.79,9.78,3.92,3.31,6.3,6.89,5.64,11.92-.68,5.21-5.02,6.78-9.29,7.75-3.87.88-7.88,1.11-10.04,1.39Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.58,71.69c-1.23,3.48-3.03,9.5-5.47,15.24-2.81,6.62-3.44,10.27,3.77,14,2.9,1.5,4.89,4.37,3.34,7.43-1.17,2.32-3.73,4.96-6.11,5.49-20.82,4.67-33.12-3.81-43.78-21.98-4.65-7.93-1.98-16.35,1.86-23.93,2.21-4.36,1.39-6.31-2.81-8.41-2.59-1.29-6.41-4.42-6.13-6.16.43-2.64,3.57-5.35,6.2-7.03,4.75-3.03,10.09-3.82,15.82-2.55,8.3,1.84,16.75,3.07,23.81,8.37,5.59,4.2,9.29,9.46,9.5,19.52Z",
    style: {
      fill: "#fefefe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.79,780.31c4.77-2.14,8.68-3.51,12.21-5.54,13.52-7.81,28.01-9.11,42.99-6.53,21.52,3.72,36.45,22.12,35.6,44.02-1.36,35.13-6.55,69.53-20.9,102.02-8.48,19.19-19.92,36.19-37,48.79-16.5,12.17-35.07,13.63-54.31,8.99-10.81-2.61-21.49-5.93-31.99-9.61C7.31,957.16-.48,946.02.02,928.94c.34-11.4,2.19-22.82,4.25-34.07,3.57-19.46,7.54-38.85,11.87-58.15,6.4-28.55,13.45-56.96,19.85-85.51,6.29-28.06,12.12-56.23,18.12-84.35,1.14-5.37,1.95-10.81,3.2-16.15.81-3.46-.26-5.55-3.6-6.43-2.89-.76-5.88-1.17-8.74-2.03-3.96-1.19-8.05-2.24-11.69-4.12-4.4-2.27-4.87-7.69-1.15-10.74,7.21-5.9,14.36-11.94,21.98-17.27,9.42-6.58,20.16-8.43,31.47-6.49,7.61,1.3,12.39,5.86,14.92,13.12,4.93,14.19,4.37,28.6,1.2,42.88-5.58,25.17-11.98,50.16-17.53,75.34-3.24,14.72-5.51,29.65-8.38,45.35Zm52.88,35.88c-1.3-7.35-1.77-13.39-3.51-19.03-2.73-8.83-9.21-12.55-18.18-10.74-8.14,1.64-16.31,3.49-24.11,6.23-3.63,1.27-7.23,4.34-9.41,7.56-2.72,4.02-4.56,8.89-5.76,13.66-5.54,22.05-11.11,44.11-15.89,66.34-2.75,12.79-4.15,25.89-5.86,38.88-.67,5.09,1.2,9.33,5.71,12.44,4.38,3.01,8.56,6.35,12.56,9.85,9.3,8.14,19.52,7.48,26.93-2.54,3.52-4.76,6.85-10.03,8.72-15.59,7.43-22.07,14.84-44.19,21.08-66.62,3.77-13.54,5.37-27.69,7.73-40.45Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.04,951.66c3.72,0,6.86-.11,9.98.03,2.65.12,5.38.17,7.9.87,3.9,1.1,7.72,2.71,7.83,7.75.08,3.73-4.54,9.07-8.51,10.01-1.45.34-3.12.34-4.32,1.08-14.65,8.98-28.88,4-43.09-1.2-2.33-.85-4.62-1.96-6.68-3.33-7.47-4.99-11.01-12.31-9.87-21,1.65-12.65,4.17-25.2,6.49-37.76,6.22-33.68,12.11-67.42,18.91-100.98,7.56-37.3,15.8-74.46,24.13-111.59,3.23-14.41,7.47-28.6,11.34-42.87,2.52-9.29,2.03-10.29-6.98-13.46-2.65-.93-5.32-1.96-7.76-3.33-3.18-1.78-3.87-4.5-1.64-7.54,9.38-12.78,26.96-23.42,46.47-16.65,7.46,2.59,11.69,7.61,13.68,15.17,3.07,11.69,3.27,23.43.84,35.15-4.2,20.18-8.87,40.27-13.16,60.43-11.1,52.09-22.25,104.17-33.07,156.32-4.29,20.67-7.81,41.5-11.56,62.28-.59,3.25-.59,6.6-.91,10.62Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.3,638.51c-.96,29.24-5.72,57.98-11.54,86.56-8.2,40.25-16.71,80.44-24.82,120.71-6.13,30.47-11.83,61.03-17.71,91.55-.28,1.47-.5,2.96-.62,4.44-.43,5.56.79,7.18,6.23,8.12,1.8.31,3.65.29,5.47.49,6.18.69,8.59,4.88,5.27,10.16-2.07,3.29-4.95,6.33-8.08,8.66-16.52,12.26-32.32,9.45-47.91-1.43-6.66-4.65-8.86-11.92-7.45-19.98,8.63-49.31,16.85-98.71,26.12-147.9,8.77-46.54,18.68-92.87,28.01-139.31,1.37-6.84,2.05-13.82,3.53-20.63,1.12-5.16-.77-8.34-5.15-10.57-1.04-.53-2.27-.89-3.04-1.69-1.28-1.34-3.21-3.04-3.11-4.47.1-1.51,1.99-3.59,3.57-4.17,4.33-1.6,8.86-3.33,13.38-3.55,6.9-.34,14.02-.24,20.78,1.07,12.15,2.35,17.37,9.63,17.08,21.96Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.67,947.55c3.75,1.67,7.57,2.95,10.94,4.97,5.69,3.41,6.02,7.81.42,11.17-14.52,8.69-30.01,10.92-45.8,3.93-9.76-4.32-14.27-15.5-11-28.34,4.01-15.74,9.56-31.08,13.83-46.76,7.85-28.85,15.31-57.81,22.73-86.78.75-2.93.1-6.23.1-9.64-2.26,0-4.05.2-5.77-.05-1.96-.29-3.87-.99-5.8-1.51.73-2.58.68-5.95,2.34-7.58,6.08-5.97,14.06-8,22.31-8.66,3.43-.27,7.01.02,10.39.71,11.4,2.33,17.07,8.93,18.43,20.49,1.7,14.4-1.79,28.05-5.44,41.75-9.21,34.57-18.24,69.18-27.33,103.78-.2.78-.22,1.6-.35,2.52Z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.47,698.99c-.62,3.76-1.07,7.55-1.91,11.26-.75,3.32-.27,5.66,2.98,7.5,1.75.99,3.26,2.9,4.19,4.74,2.69,5.33.91,8.75-4.6,10.61-14.11,4.78-27.26.67-40.22-4.32-5-1.93-8.51-9.66-7.72-15.62.72-5.43,1.69-10.83,2.81-16.19.76-3.65-.51-5.88-3.96-6.8-3.13-.83-5.81-2.1-5.73-5.8.09-4.1,3.71-4.24,6.48-4.94,6.28-1.58,12.59-3.06,18.95-4.29,15.99-3.1,28.43,7.4,28.74,23.86Z",
    style: {
      fill: "#fefefe"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.29,541.12l412.34,9.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.29,425.33l412.34,9.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "my_name_is",
    "data-name": "my name is"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m437.7,475.85c-2.83-1.69-6.16-3.45-9.27-2.36-2.43.85-3.97,3.19-5.32,5.38-.73,1.18-1.47,2.4-1.63,3.78-.32,2.83,1.95,5.32,4.4,6.79,2.44,1.47,5.25,2.41,7.31,4.38,3.64,3.5,3.65,10.07.01,13.59-3.63,3.51-10.19,3.28-13.56-.49",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.76,470.58c.5,13.54.34,27.1-.49,40.62-.03.48.02,1.1.46,1.26.44.16.6-.87.17-.67",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m314.5,473.44c-2.37,10.79.76,22.07-.46,33.05,3.93-.11,7.86-.21,11.78-.32.25,0,.53-.04.66-.25s-.18-.55-.33-.36",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.11,488.47c4.91.66,9.91.69,14.82.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.11,488.47c4.91.66,9.91.69,14.82.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.11,488.47c4.91.66,9.91.69,14.82.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.21,472.87c4.53-1.06,9.26-1.28,13.87-.65",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.56,508.99c.26-15.09.52-30.19.78-45.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.64,509.92c-1.32-15.67-1.39-31.45-.2-47.13l-17.02,34.83-15.79-33.67",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m219.05,509.37c.56-13.46,2.14-26.88,4.72-40.09,3.33-.65,6.75-.84,10.13-.58,1.28,13.69,2.56,27.37,3.84,41.06",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.87,490.93c2.57-1.83,5.88-2.53,8.94-1.88",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.93,508.78c.04-12.9.09-25.79.82-39.21,3.29,13.72,12.42,25.07,18.08,37.93",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.93,471.46c.18,11.49.36,22.98.54,34.47,0,.32.06.71.35.82.29.11.49-.52.18-.48",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m78.97,461.98c4.82,6.64,8.93,13.78,12.76,22.01l12.92-23.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.38,483.99l.43,22.94",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m259.63,511.11c.25-14.62.51-29.25.76-43.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.69,512.01c-1.28-15.18-1.35-30.47-.19-45.67l-16.49,33.74-15.3-32.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHi);
export default __webpack_public_path__ + "static/media/hi.0b5fdde5a92512df1c3eaabb896bdc74.svg";
export { ForwardRef as ReactComponent };